<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

/* 全局公用样式 */
<style src="./assets/css/app.css"></style>
